const THEMES = [
  'healthy',
  'accident',
  'financing', // 理财
  'financing2', // 深金
  'financing3', // 金
  'diff', // 对比/开门红
  'children', // 儿童
  'policy' // 保单年检
]

const COMMON_IMAGE_PATH = 'https://media.winbaoxian.com/assets-uploader/'
const DEFAULT_BANNER_V2 = {
  healthy: `${COMMON_IMAGE_PATH}healthy%401x-1706780098644.jpg`,
  accident: `${COMMON_IMAGE_PATH}accident%401x-1706780098644.jpg`,
  financing3: `${COMMON_IMAGE_PATH}financing3%401x-1706780098644.jpg`,
  financing2: `${COMMON_IMAGE_PATH}financing2%401x-1706780098644-1706939453371.jpg`,
  financing: `${COMMON_IMAGE_PATH}financing%401x-1706780098644.jpg`,
  diff: `${COMMON_IMAGE_PATH}diff%401x-1706780098644-1706939375473.jpg`,
  children: `${COMMON_IMAGE_PATH}children%401x-1706780098644.jpg`
}

// bannerHeight：可不传，默认 235。取值规则: = 375（标准屏宽）/ 750（图片宽度）* 470（图片高度）
export const THEME_OPTIONS = [
  {
    key: 'theme_lndj',
    name: '2024，龙年大吉',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%208%E5%A4%87%E4%BB%BD%402x-1706144838010-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_lndj2',
    name: '龙年大吉，新岁新程，美好可期',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/WechatIMG3640-1706931802212.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_ghxx',
    name: '恭贺新禧',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%208%402x-1706144912546-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_jlhcwsss',
    name: '金龙贺春，万事顺遂',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/WechatIMG3615-1706929158653.jpg',
      bannerHeight: null
    }
  },
  {
    key: 'theme_lxddqcll',
    name: '龙行龘龘（dá），前程朤朤（lǎng）',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/WechatIMG3632-1706931459315.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_bxhjrssdgg',
    name: '保险，缓解人生三大尴尬',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%205%402x-1706157159977-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_bwnxbrbwnj',
    name: '百万年薪，不如百万年金',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/Group%203%20Copy%402x-1706144636578-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_ghzzyrs',
    name: '给孩子自由人生',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x-1706144698686-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_pbhzczdlw',
    name: '陪伴孩子成长的礼物',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x%202-1706144774771-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_rfyr',
    name: '日富一日',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%208%402x-1706145318139-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_xzyadlyq',
    name: '心中有爱，兜里有钱',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/diff%401x-17067800985644-1706939541788.jpg',
      bannerHeight: null
    }
  },
  {
    key: 'theme_cfzzxxz',
    name: '财富增值新选择',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%204%402x(1)-1706145237612-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_tpzcthb',
    name: '突破职场天花板',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/diff%401x-17067800986w44-1706939494309.jpg',
      bannerHeight: null
    }
  },
  {
    key: 'theme_xzqdczjdsjks',
    name: '选择确定成长，静待时间犒赏',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x%205-1706754238842-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_mdehddycfbwz',
    name: '谋定而后动，打赢财富保卫战',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x-1706754384995-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_zzqdxzsjjsda',
    name: '做正确的选择，时间就是答案',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x%202-1706754452004-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_bffmst',
    name: '不负父母所托',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x%203-1706754539988-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_lysylysy',
    name: '老有所依，老有所养',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x%20(1)-1709171179181.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_ywmdmheacrlq',
    name: '愿我们都满怀热爱，从容老去',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%2010%402x%204-1706754718268-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_qddcfcz',
    name: '确定的财富成长',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/Group%205%20Copy%402x-1706754793741-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_shzcxyrakysj',
    name: '守护传承心愿，让爱跨越时间',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/Group%402x-1706754893430-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_bxbjsbz',
    name: '保险不仅是保障',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/Group%20Copy%402x-1706779690607.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_cqzywzdx',
    name: '长期主义，稳字当先',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/Group%20Copy%402x-1706754979087-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_yyylyxhtqgh',
    name: '优雅养老，要学会提前规划',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%208%402x-1706755073885-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_hbzmsyhm',
    name: '合抱之木，生于毫末',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%208%402x%203-1706755229171-1706772368676.png',
      bannerHeight: null
    }
  },
  {
    key: 'theme_cysjgwldzjczdqhzf',
    name: '穿越时间，给未来的自己充足底气和祝福',
    config: {
      bannerImage: 'https://media.winbaoxian.com/assets-uploader/%E7%BC%96%E7%BB%84%208%402x%202-1706756207759-1706772368676.png',
      bannerHeight: null
    }
  }
]

const THEME_NAMES = {
  'healthy': '保险让生活更美好（蓝色）',
  'accident': '保险让生活更美好（蓝色）',
  'financing': '保险让生活更美好（橙色）',
  'financing2': '保险让生活更美好（蓝金）',
  'financing3': '保险让生活更美好（浅色）',
  'diff': '保险让生活更美好（开门红）',
  'children': '保险让生活更美好（儿童）'
}

const OLD_THEME_OPTIONS = THEMES.map(key => ({
  key,
  name: THEME_NAMES[key] || `主题 ${key}`,
  config: {
    bannerImage: DEFAULT_BANNER_V2[key],
    bannerHeight: null
  }
}))
export const MODEN_THEMES = THEME_OPTIONS.concat(OLD_THEME_OPTIONS).filter(e => e.config.bannerImage)

export function getBannerByTheme (theme) {
  const item = MODEN_THEMES.find(it => it.key === theme)
  return item && item.config.bannerImage
}

export function getThemeName (theme, options = []) {
  const item = options.find(it => it.key === theme)
  return item && item.name || ''
}

export function getSafeTheme ({previewTheme, defaultTheme} = {}) {
  return THEMES.includes(previewTheme) ? previewTheme : (THEMES.includes(defaultTheme) ? defaultTheme : THEMES[0])
}

export function getDefaultTheme () {
  return MODEN_THEMES[0]
}
